import CatatanTransaksiHarianApi from "./CatatanTransaksiHarianApi";

export default CatatanTransaksiHarianApi;
